import React from "react";
import ReservationForm from "../components/ReservationForm";
import ReservationBanner from "../components/ReservationBanner";
const Reservation = () => {
  return (
    <div>
      <ReservationForm />
      <ReservationBanner />
    </div>
  );
};

export default Reservation;
